import { render, staticRenderFns } from "./UserStory.vue?vue&type=template&id=fd840962&scoped=true&"
import script from "./UserStory.vue?vue&type=script&lang=js&"
export * from "./UserStory.vue?vue&type=script&lang=js&"
import style0 from "./UserStory.vue?vue&type=style&index=0&id=fd840962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd840962",
  null
  
)

export default component.exports